import { sortBy } from "lodash";
import { DateTime } from "luxon";
import * as z from "zod";

export const ALL_VERSIONS = [
  "original",
  "tldr",
  "bible",
  "crochet",
  "pirate",
  "socrates",
  "shakespeare",
  "spongebob",
  "frasier",
  "harry-potter",
  "horizon",
  "better_dan",
  "haiku",
  "caveman",
  "evil",
  "simpsons",
  "jason_mendoza",
  "iphone",
  "summarize",
  "niles",
] as const;

const DISABLED_VERSIONS = ["simpsons", "iphone", "niles"];

export function isVersionEnabled(version: Version) {
  return !DISABLED_VERSIONS.includes(version);
}

export type Version = (typeof ALL_VERSIONS)[number];

export const VersionSchema = z.enum(ALL_VERSIONS);

export function sortVersions(versions: Version[]): Version[] {
  return sortBy(versions, (v) => ALL_VERSIONS.indexOf(v));
}

export function prettyPrintVersion(version: Version) {
  switch (version) {
    case "original":
      return "Original";
    case "tldr":
      return "TL;DR";
    case "bible":
      return "Heavenly Hits: Psalms of the Fiend";
    case "pirate":
      return "Rum-Soaked Redemption";
    case "horizon":
      return "Horizon: Zero Dawn";
    case "better_dan":
      return "BetterDAN: Beyond Morality";
    case "haiku":
      return "Dope Poetry: Haikus for Addicts";
    case "caveman":
      return "Stone Age Struggles";
    case "harry-potter":
      return "Harry Potter and the Cauldron of Cravings";
    case "spongebob":
      return "Pills & Pineapples";
    case "frasier":
      return "Frasier: Needles and Neuroses";
    case "socrates":
      return "Chasing Eudaimonia";
    case "crochet":
      return "The Unraveling: A Hooker's Yarny Hell";
    case "evil":
      return "Evil Confidant";
    case "simpsons":
      return "Breaking Bart";
    case "jason_mendoza":
      return "Jason Mendoza: Molotov Your Way to Happiness";
    case "iphone":
      return "Android or iPhone?";
    case "shakespeare":
      return "Much Ado about Recovery: Shakespearean Sonnets";
    case "summarize":
      return "Progressive Summarization";
    case "niles":
      return "Niles and Maris: A Love Story";
    default:
      return version;
  }
}

export interface JFT {
  title: string;
  excerpt?: string;
  excerpt_source?: string;
  body: string;
  jft_principle?: string;
  date: DateTime;
  version: Version;
  audio_file?: string;
}

export interface LoaderData {
  jfts: JFT[];
  versions: Version[];
  date: { month: number; day: number };
}
